import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { CustomNotification } from 'common/components';
import { saveQaSpecDataClaims } from 'services/product';
import { getKeyProductSpec } from 'pages/qa-spec/hooks/useProductSpecInfo';
import { forwardTo } from 'utils/common/route';

import * as productServices from 'services/product';
import { getQaPackagingTabDataQueryKey } from 'pages/qa-spec/components/qa-packaging/queries';
import { keyGetProductItemModules } from 'pages/product-full-view/shared/hooks';

export const getQaClaimsTabDataQueryKey = (productId) => {
  return ['qa-spec', parseInt(productId), 'qa-spec-data-claims'];
};

export const useGetQaClaimsTabData = ({ productId }, options) => {
  return useQuery({
    queryKey: getQaClaimsTabDataQueryKey(productId),
    queryFn: async () => {
      const response = await productServices.getQaClaimsData({ productId });
      if (response?.isSuccess) {
        return response?.data;
      } else {
        CustomNotification.error(response?.message ?? 'Something went wrong!');
        forwardTo('/products');
      }
    },
    ...options,
  });
};

export const useSaveQaClaimsTab = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ productId, formData }) => {
      const params = { productId, ...formData };
      const response = await saveQaSpecDataClaims(params);
      const { isSuccess, data, message } = response || {};

      if (isSuccess) {
        return Promise.resolve(data);
      } else if (message) {
        return Promise.reject(message);
      }
    },
    onSuccess: (data, { productId }) => {
      queryClient.invalidateQueries({
        queryKey: getQaClaimsTabDataQueryKey(productId),
      });
      //* sync to qa product spec
      queryClient.invalidateQueries({
        queryKey: getKeyProductSpec(productId),
      });
      //* sync to product labeling
      queryClient.invalidateQueries({
        queryKey: getQaPackagingTabDataQueryKey(productId),
      });
      //* sync to product detail view
      queryClient.invalidateQueries({
        queryKey: keyGetProductItemModules(productId),
      });
      CustomNotification.success('Update Claim data successfully!');
    },
    onError: (error) => {
      CustomNotification.error(error || 'Server Error');
    },
  });
};
